import { Badge } from '@/components/ui/Badge';
import type { DrugSchedule } from './types';

/**
 * All four legacy SCHEDULE_META colours turned out to be exact matches for
 * existing (or, for H1, newly promoted — see theme.css) Badge variants, so
 * this is a thin label+variant map rather than its own bespoke component.
 */
const SCHEDULE_META: Record<DrugSchedule, { label: string; variant: 'neutral' | 'info' | 'caution' | 'danger' }> = {
  OTC: { label: 'OTC', variant: 'neutral' },
  H: { label: 'Rx (H)', variant: 'info' },
  H1: { label: 'H1', variant: 'caution' },
  X: { label: 'Sched. X', variant: 'danger' },
};

export function ScheduleBadge({ schedule }: { schedule: DrugSchedule }) {
  const meta = SCHEDULE_META[schedule] || SCHEDULE_META.OTC;
  return <Badge variant={meta.variant}>{meta.label}</Badge>;
}
